import React from 'react';
import { PlusIcon } from '../icons/SvgIcons';
import { PrimaryButton } from '../components/ui/Button/Buttons';

export type DashboardLayoutProps = Readonly<{
  children: React.ReactNode;
  title: string;
  description?: string;
  onAddButtonClick?: () => void;
  addButtonText?: string;
  addButtonAction?: React.ReactNode;
  addButtonDisabled?: boolean;
  secondButtonText?: string;
  secondButtonOnClick?: () => void;
  secondButtonDisabled?: boolean;
  scrollContainerRef?: React.Ref<HTMLDivElement>;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
}>;

export function DashboardLayout({
  children,
  title,
  description,
  onAddButtonClick,
  addButtonText,
  addButtonAction,
  addButtonDisabled = false,
  secondButtonText,
  secondButtonOnClick,
  secondButtonDisabled = false,
  scrollContainerRef,
  onScroll
}: DashboardLayoutProps) {
  const showAddButton = addButtonText != null;
  const showAddButtonAction = addButtonAction != null;
  const showSecondButton = secondButtonText != null;
  return (
    <div
      ref={scrollContainerRef}
      onScroll={onScroll}
      className="flex-1 flex flex-col overflow-auto bg-gray-60"
    >
      <div className="pt-6 px-6 pb-4">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <h1 className="font-inter text-xl font-semibold text-gray-900 text-left">
              {title}
            </h1>
            {description && (
              <p className="font-inter text-base text-left font-normal text-gray-900">
                {description}
              </p>
            )}
          </div>
          <div className="flex flex-row gap-2">
            {showAddButtonAction ? (
              addButtonAction
            ) : (
              showAddButton && (
                <PrimaryButton
                  onClick={onAddButtonClick}
                  disabled={addButtonDisabled}
                  icon={PlusIcon()}
                  size="base"
                  className="w-auto"
                >
                  {addButtonText}
                </PrimaryButton>
              )
            )}
            {showSecondButton && (
              <PrimaryButton
                onClick={secondButtonOnClick}
                disabled={secondButtonDisabled}
                icon={PlusIcon()}
                size="base"
                className="w-auto"
              >
                {secondButtonText}
              </PrimaryButton>
            )}
          </div>
        </div>
      </div>
      <div className="flex-1 flex justify-center items-start px-4 pb-4 gap-4">
        {children}
      </div>
    </div>
  );
}
